import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import LocationForm from './LocationForm'

import { storeLocation } from '../services'
import { handleError } from '../../../helpers'

export default function NewLocationModal({ visible, onClose, reload, company }) {
	const { handleSubmit, register, formState: { errors }, setValue } = useForm({
		defaultValues: { company_id: company ? company.id : null }
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		storeLocation(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Agregar Sede Nueva</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<LocationForm 
							register={register}
							errors={errors}
							setValue={setValue}
							company={company}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Agregar Registro
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}